import "./index.less";
import * as React from "react";
import { AtContainer } from "@atman/design-system";
import { CompDevTabHeader } from "../CompDevTabHeader";
import {
    CompetencyDevelopmentAssessmentType,
    CompetencyDevelopmentProcessData,
    CompetencyDevelopmentProcessResultsData,
    PrintModeEnum,
} from "@atman/business";
import { TeamDevelopmentActionPlanObjectivesSection } from "./components/TeamDevelopmentActionPlanObjectivesSection";
import { observer } from "mobx-react";

export interface ITeamDevelopmentActionPlanProps {
    candidateProcessData?: CompetencyDevelopmentProcessData;
    candidateProcessResultsData: CompetencyDevelopmentProcessResultsData;
    printMode?: PrintModeEnum;
    openAndMonitorTabFunc?: (url: string) => void;
}

export const TeamDevelopmentActionPlan: React.FC<ITeamDevelopmentActionPlanProps> = observer((props) => {
    const { candidateProcessData, candidateProcessResultsData, printMode, openAndMonitorTabFunc } = props;

    const competenciesToLeverageAssessment = candidateProcessData?.assessmentsData.get(
        CompetencyDevelopmentAssessmentType.CompetenciesToLeverage,
    );
    const competenciesToImproveAssessment = candidateProcessData?.assessmentsData.get(
        CompetencyDevelopmentAssessmentType.CompetenciesToImprove,
    );

    return (
        <div id="TeamDevelopmentActionPlan">
            <AtContainer>
                <CompDevTabHeader
                    title={"competencyDevelopment.actionPlan".localize()}
                    subTitle={"competencyDevelopment.actionPlan.description".localize()}
                />
            </AtContainer>
            <TeamDevelopmentActionPlanObjectivesSection
                type={"leverage"}
                candidateProcessResultsData={candidateProcessResultsData}
                processAssessmentData={competenciesToLeverageAssessment}
                openAndMonitorTabFunc={openAndMonitorTabFunc}
                printMode={printMode}
            />
            <TeamDevelopmentActionPlanObjectivesSection
                type={"improve"}
                candidateProcessResultsData={candidateProcessResultsData}
                processAssessmentData={competenciesToImproveAssessment}
                openAndMonitorTabFunc={openAndMonitorTabFunc}
                printMode={printMode}
            />
        </div>
    );
});
